import React, { useState, useEffect } from "react";
import API_DOMAIN from "../config/config";
import {
  Container,
  Row,
  Col,
  Table,
  Button,
  Modal,
  Tab,
  Tabs,
} from "react-bootstrap";
import {
  Calender,
  DropDown,
  InstantModel,
  TextInputForm,
  DropDownUI,
  DropDownUItest,
} from "../components/Forms";
import { PageHead } from "../components/PageTitle";
import { MdOutlineDeleteOutline } from "react-icons/md";
import { useNavigate, Navigate } from "react-router-dom";
import {
  Buttons,
  Dltbtn,
  InstantCreate,
  ClickButton,
  Delete,
} from "../components/Buttons";
import { BiPlus } from "react-icons/bi";
import { useLocation } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { MdDeleteForever } from "react-icons/md";
import moment from "moment/moment";
import companyId from "../config/companyId";
import "./salesbills.css";
const alltax = [
  {
    value: "GST@0%",
    label: "GST@0%",
  },
  {
    value: "IGST@5%",
    label: "IGST@5%",
  },
  {
    value: "GST@5%",
    label: "GST@5%",
  },
];
// saleinvoice start
const SalesInvoiceEntry = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { type, rowData } = location.state || {};
  const [showModal, setShowModal] = useState(false);
  const [toggled, setToggled] = useState(false);
  const [discountType, setDiscountType] = useState(
    rowData?.discount_type || "Discount %"
  );
  const [globalTax, setGlobalTax] = useState({
    tax_type: rowData?.gst_type ? rowData.gst_type.split("@")[0] : "GST",
    tax_percentage: rowData?.gst_type
      ? parseFloat(rowData.gst_type.match(/\d+\.*\d*/)?.[0] || 0)
      : 0,
    tax_label: rowData?.gst_type || "GST@0%",
  });
  const initialState =
    type === "edit"
      ? {
        ...rowData,
        party_id: rowData.party_id || rowData.party_details?.party_id || "",
        bill_no: rowData.bill_no || "",
        party_name:
          rowData.party_name || rowData.party_details?.party_name || "",
        discount:
          rowData.discount !== undefined ? rowData.discount.toString() : "0",
        discount_type: rowData.discount_type || "Discount %",
        subtotal: rowData.sub_total || "0",
        paid: rowData.paid || "0",
        balance_amount: rowData.balance || "0",
        round_off: parseInt(rowData.round_off) || 0,
        round_off_amount: rowData.round_off_amount
          ? rowData.round_off_amount.toString()
          : "0",
        round_off_checkbox: parseInt(rowData.round_off) === 1,
        total: (
          parseFloat(rowData.sub_total || 0) -
          (rowData.discount_type === "Discount Amount"
            ? parseFloat(rowData.discount || 0)
            : (parseFloat(rowData.sub_total || 0) *
              parseFloat(rowData.discount || 0)) /
            100) +
          parseFloat(rowData.gst_amount || 0)
        ).toFixed(2),
        product: rowData.product.map((product) => ({
          product_id: product.product_id,
          product_name: product.product_name || "",
          qty: product.qty,
          unit: product.unit,
          unit_name: product.unit_name,
          unit_count: product.unit_count || "",
          batch: product.batch || "",
          price_unit: product.price_unit,
          discount_percentage: product.discount_percentage || "0",
          discount_amt: product.discount_amt || "0",
          total_amt: product.total_amt || "0",
        })),
        payment_method: rowData.payment_method || "",
        bill_date:
          rowData.bill_date && moment(rowData.bill_date).isValid()
            ? moment(rowData.bill_date).format("YYYY-MM-DD")
            : moment().format("YYYY-MM-DD"),
      }
      : {
        party_id: "",
        party_name: "",
        eway_no: "",
        vechile_no: "",
        bill_date: moment().format("YYYY-MM-DD"),
        state_of_supply: "",
        mobile_number: "",
        address: "",
        total: "",
        subtotal: "",
        paid: "0",
        balance_amount: "",
        final_total: "",
        discount: "",

        discount_type: "Discount %",
        total_discountall: "",
        round_off_checkbox: false,
        round_off: 0,
        round_off_amount: "0",
        remark: "",
        payment_method: "",

        product: [
          {
            product_id: "",
            product_name: "",
            qty: "",
            unit: "",
            unit_name: "",
            unit_count: "",
            batch: "",
            price_unit: "",
            discount_percentage: "",
            discount_amt: "",
            total_amt: "",
          },
        ],
      };
  const [formData, setFormData] = useState(initialState);

  console.log("formdata", formData)
  const [formDataPartySales, setformDataPartySales] = useState({
    bill_no: "",
    party_id: "",
    party_name: "",
    mobile_number: "",
    alter_number: "",
    email: "",
    company_name: "",
    gst_no: "",
    address: "",
    opening_balance: "",
    opening_date: "",
    ac_type: "",
  });
  const [loading, setLoading] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [productData, setProductData] = useState([]);
  const [UnitData, setUnitData] = useState([]);
  const [partySalesData, setPartySalesData] = useState([]);
  const [crtPaymentMethod, setCrtPaymentMethod] = useState([]);
  const handleRoundOffChange = (e) => {
    const checked = e.target.checked;
    setFormData((prev) => ({
      ...prev,
      round_off_checkbox: checked,
      round_off: checked ? 1 : 0,
      round_off_amount: checked
        ? (
          Math.round(parseFloat(prev.total) || 0) - parseFloat(prev.total) ||
          0
        ).toFixed(2)
        : "0",
    }));
  };
  useEffect(() => {
    if (formData.round_off_checkbox) {
      const total = parseFloat(formData.total) || 0;
      const rounded = Math.round(total);
      const roAmount = (rounded - total).toFixed(2);
      setFormData((prev) => ({
        ...prev,
        round_off_amount: roAmount,
      }));
    }
  }, [formData.total, formData.round_off_checkbox]);
  const setLabel = (value, field) => {
    if (!value || !moment(value).isValid()) {
      return;
    }
    setFormData({
      ...formData,
      [field]: moment(value).format("YYYY-MM-DD"),
    });
  };
  const setLabell = (value, field) => {
    setformDataPartySales({
      ...formDataPartySales,
      [field]: moment(value).format("YYYY-MM-DD"),
    });
  };
  useEffect(() => {
    const fetchProductData = async () => {
      try {
        const response = await fetch(
          `${API_DOMAIN}/products.php?id=${companyId}`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              search_text: "",
            }),
          }
        );
        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }
        const responseData = await response.json();
        setLoading(false);
        if (responseData.status === 200 && Array.isArray(responseData.data)) {
          const validData = responseData.data.filter(
            (item) => item && typeof item.product_name === "string"
          );
          setProductData(validData);
        } else {
          throw new Error(responseData.msg);
        }
      } catch (error) {
        setLoading(false);
      }
    };
    fetchProductData();
  }, []);
  const fetchUnitData = async () => {
    try {
      const response = await fetch(`${API_DOMAIN}/unit.php?id=${companyId}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          search_text: "",
        }),
      });
      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }
      const responseData = await response.json();
      if (responseData.status === 200) {
        setUnitData(responseData.data);
      } else {
        throw new Error(responseData.msg);
      }
    } catch (error) {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchUnitData();
  }, []);
  const fetchPartySalesData = async () => {
    try {
      const companyIdLocal = localStorage.getItem("companyId");
      const response = await fetch(`${API_DOMAIN}/sales_party.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          search_text: "",
          company_id: companyIdLocal,
        }),
      });
      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }
      const responseData = await response.json();
      setLoading(false);
      if (responseData.code === 200) {
        setPartySalesData(responseData.data);
      } else {
        throw new Error(responseData.msg);
      }
    } catch (error) {
      setLoading(false);
    }
  };
  const fetchDataPaymentMethod = async () => {
    try {
      const companyId = localStorage.getItem("companyId");
      const response = await fetch(
        `${API_DOMAIN}/paymentmethod.php?id=${companyId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            search_text: "",
          }),
        }
      );
      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }

      const responseData = await response.json();
      if (responseData.status === 200) {
        setCrtPaymentMethod(responseData.data);
      } else {
        throw new Error(responseData.msg);
      }
    } catch (error) {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchPartySalesData(); // Call fetchData directly in useEffect
    fetchDataPaymentMethod();
  }, []);
  const errorAlert = (input) => {
    toast.error(input, {
      position: "top-center",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });
  };
  const successAlert = (success) => {
    toast.success(success, {
      position: "top-center",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });
  };
  const calculateTotal = () => {
    const totalAmount = formData.product.reduce(
      (acc, row) => acc + (parseFloat(row.total_amt) || 0),
      0
    );
    const discountValue = parseFloat(formData.discount) || 0;
    const discountAmount =
      discountType === "Discount %"
        ? ((totalAmount * discountValue) / 100).toFixed(2)
        : discountValue.toFixed(2);
    const discountedSubtotal =
      discountType === "Discount %"
        ? (totalAmount - (totalAmount * discountValue) / 100).toFixed(2)
        : (totalAmount - discountValue).toFixed(2);
    const taxRate = parseFloat(globalTax.tax_percentage) || 0;
    const taxAmount = (discountedSubtotal * taxRate) / 100;
    const finalTotal = (parseFloat(discountedSubtotal) + taxAmount).toFixed(2);
    setFormData((prevData) => ({
      ...prevData,
      subtotal: totalAmount.toFixed(2),
      discount_amount: discountAmount,
      total: finalTotal,
    }));
  };
  const handleSubmit = async () => {
    if (!formData.party_id) {
      errorAlert("Please select a party.");
      return;
    }
    try {
      setLoading(true);
      const subtotal = parseFloat(formData.subtotal) || 0;
      const discountValue = parseFloat(formData.discount) || 0;
      const discountAmount =
        discountType === "Discount %"
          ? ((subtotal * discountValue) / 100).toFixed(2)
          : discountValue.toFixed(2);
      const discountedSubtotal =
        discountType === "Discount %"
          ? (subtotal - (subtotal * discountValue) / 100).toFixed(2)
          : (subtotal - discountValue).toFixed(2);
      const taxRate = parseFloat(globalTax.tax_percentage) || 0;
      const taxAmount = (discountedSubtotal * taxRate) / 100;
      const baseTotal = (parseFloat(discountedSubtotal) + taxAmount).toFixed(2);
      const grandTotal = (
        parseFloat(baseTotal) + parseFloat(formData.round_off_amount || 0)
      ).toFixed(2);

      const { party_name, party_details, ...baseData } = formData;
      const sanitizedFormData = {
        ...baseData,
        party_id: formData.party_id,
        party_name: formData.party_name,
        payment_method: formData.payment_method,
        discount_type: discountType,
        gst_type: globalTax.tax_label,
        gst_amount: taxAmount.toFixed(2),
        discount_amount: discountAmount,
        paid: formData.paid,
        balance_amount: formData.balance_amount,
        round_off: formData.round_off,
        round_off_amount: formData.round_off_amount,
        total: grandTotal,

        product: formData.product.map((product) => ({
          product_id: product.product_id,
          product_name: product.product_name,
          qty: product.qty,
          unit: product.unit,
          unit_name: product.unit_name,
          unit_count: product.unit_count,
          batch: product.batch || "",
          price_unit: product.price_unit,
          discount_percentage: product.discount_percentage,
          discount_amt: product.discount_amt,
          total_amt: product.total_amt,
        })),
        sub_total: formData.subtotal,
        discount: formData.discount,
        balance: formData.balance_amount,
        sum_total: formData.product
          .reduce(
            (acc, row) =>
              acc +
              ((parseFloat(row.qty) || 0) * (parseFloat(row.price_unit) || 0) -
                (parseFloat(row.discount_amt) || 0)),
            0
          )
          .toFixed(2),
      };
      const response = await fetch(
        `${API_DOMAIN}/salesinvoice.php?id=${companyId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(sanitizedFormData),
        }
      );
      setLoading(false);
      const responseData = await response.json();
      if (responseData.status === 200) {
        setFormData(initialState);
        setGlobalTax({
          tax_type: "GST",
          tax_percentage: 0,
          tax_label: "GST@0%",
        });
        successAlert(responseData.msg);
        setTimeout(() => {
          navigate("/console/sales/invoice");
        }, 2000);
      } else {
        handleErrors(responseData);
      }
    } catch (error) {
      errorAlert(error.message);
    }
  };
  const handleErrors = (responseData) => {
    if (responseData.status === 400) {
      toast.error(responseData.msg, {
        position: "top-center",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    } else {
      setShowAlert(true);
    }
  };
  const handleUpdateSubmit = async () => {
    if (!formData.party_id) {
      errorAlert("Please select a party.");
      return;
    }
    try {
      setLoading(true);
      const sum_total = formData.product
        .reduce(
          (acc, row) =>
            acc +
            ((parseFloat(row.qty) || 0) * (parseFloat(row.price_unit) || 0) -
              (parseFloat(row.discount_amt) || 0)),
          0
        )
        .toFixed(2);
      const subtotal = parseFloat(formData.subtotal) || 0;
      const discount = parseFloat(formData.discount) || 0;
      const discountAmount =
        discountType === "Discount %"
          ? ((subtotal * discount) / 100).toFixed(2)
          : discount.toFixed(2);
      const discountedSubtotal =
        discountType === "Discount %"
          ? (subtotal - (subtotal * discount) / 100).toFixed(2)
          : (subtotal - discount).toFixed(2);
      const taxRate = parseFloat(globalTax.tax_percentage) || 0;
      const taxAmount = (discountedSubtotal * taxRate) / 100;
      const baseTotal = (parseFloat(discountedSubtotal) + taxAmount).toFixed(2);
      const grandTotal = (
        parseFloat(baseTotal) + parseFloat(formData.round_off_amount || 0)
      ).toFixed(2);
      const paid = formData.paid;
      const balance = formData.balance_amount;

      const { party_name, party_details, ...baseData } = formData;
      const requestBody = {
        ...baseData,
        party_id: formData.party_id,
        party_name: formData.party_name,
        payment_method: formData.payment_method,
        discount_type: discountType,
        gst_type: globalTax.tax_label,
        gst_amount: taxAmount.toFixed(2),
        discount_amount: discountAmount,
        round_off: formData.round_off,
        round_off_amount: formData.round_off_amount,
        total: grandTotal,

        product: formData.product.map((product) => ({
          product_id: product.product_id,
          product_name: product.product_name || "",
          qty: product.qty,
          unit: product.unit,
          unit_name: product.unit_name,
          unit_count: product.unit_count || "",
          batch: product.batch || "",
          price_unit: product.price_unit,
          discount_percentage: product.discount_percentage,
          discount_amt: product.discount_amt,
          total_amt: product.total_amt,
        })),
        invoice_id: rowData.invoice_id,
        sub_total: formData.subtotal,
        discount: formData.discount,
        sum_total: sum_total,
        paid: paid,
        balance: balance,
      };
      const response = await fetch(
        `${API_DOMAIN}/salesinvoice.php?id=${companyId}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
        }
      );
      // console.log("requestBody", JSON.stringify(requestBody));
      const responseData = await response.json();
      if (responseData.status === 200) {
        toast.success("Sales Invoice updated successfully!", {
          position: "top-center",
          autoClose: 2000,
          theme: "colored",
        });
        setTimeout(() => {
          navigate("/console/sales/invoice");
        }, 2000);
      } else {
        toast.error(responseData.msg || "Failed to update invoice", {
          position: "top-center",
          autoClose: 2000,
          theme: "colored",
        });
      }
    } catch (error) {
      toast.error("Error updating invoice: " + error.message, {
        position: "top-center",
        autoClose: 2000,
        theme: "colored",
      });
    } finally {
      setLoading(false);
    }
  };
  const [showQtyModal, setShowQtyModal] = useState(false);
  const [currentQtyRowIndex, setCurrentQtyRowIndex] = useState(null);
  const [additionalQty, setAdditionalQty] = useState("");

  const handleOpenQtyModal = (index) => {
    setCurrentQtyRowIndex(index);
    setAdditionalQty("");
    setShowQtyModal(true);
  };

  const handleQtyAddition = () => {
    if (currentQtyRowIndex === null) return;
    const currentQty = parseFloat(formData.product[currentQtyRowIndex].qty) || 0;
    const addQty = parseFloat(additionalQty) || 0;
    const newQty = (currentQty + addQty).toString();

    // Trigger calculation by calling handleChange with the new quantity
    handleChange({ target: { value: newQty } }, "qty", currentQtyRowIndex);

    setShowQtyModal(false);
    setAdditionalQty("");
    setCurrentQtyRowIndex(null);
  };

  const handleAddRow = () => {
    setFormData((prevState) => ({
      ...prevState,
      product: [
        ...prevState.product,
        {
          product_id: "",
          product_name: "",
          qty: "",
          unit: "",
          unit_name: "",
          unit_count: "",
          batch: "",
          price_unit: "",
          discount_percentage: "",
          discount_amt: "",
          total_amt: "",
        },
      ],
    }));
  };
  const handleDeleteRow = (index) => {
    setFormData((prevState) => ({
      ...prevState,
      product: prevState.product.filter((_, i) => i !== index),
    }));
  };
  const handleChangePartySales = (e, fieldName) => {
    const value = e.target ? e.target.value : e.value;
    setformDataPartySales({
      ...formDataPartySales,
      [fieldName]: value,
    });
  };
  const handlePaidChange = (e) => {
    const value = parseFloat(e.target.value) || 0;
    setFormData((prevFormData) => ({
      ...prevFormData,
      paid: value.toString(),
    }));
  };
  const handleChange = (e, fieldName, rowIndex) => {
    const value = e.target ? e.target.value : e.value;
    let updatedFormData = { ...formData };
    if (rowIndex !== undefined) {
      updatedFormData = {
        ...formData,
        product: formData.product.map((row, index) =>
          index === rowIndex ? { ...row, [fieldName]: value } : row
        ),
      };
    } else {
      updatedFormData = {
        ...formData,
        [fieldName]: value,
      };
    }
    updatedFormData.product.forEach((row, index) => {
      const qty = parseFloat(row.qty) || 0;
      const price = parseFloat(row.price_unit) || 0;
      const discountPercentage = parseFloat(row.discount_percentage) || 0;
      const discountInputAmount = parseFloat(row.discount_amt) || 0;
      let crtdiscountFiled = 0.0;
      let subtotal = qty * price;
      if (fieldName === "price_unit" || fieldName === "qty") {
        crtdiscountFiled = isNaN(discountPercentage)
          ? 0
          : (subtotal * discountPercentage) / 100;
        updatedFormData.product[index].discount_amt =
          crtdiscountFiled.toFixed(2);
      }
      if (fieldName === "discount_percentage") {
        crtdiscountFiled = isNaN(discountPercentage)
          ? 0
          : (subtotal * discountPercentage) / 100;
        updatedFormData.product[index].discount_amt =
          crtdiscountFiled.toFixed(2);
      } else if (fieldName === "discount_amt") {
        crtdiscountFiled = discountInputAmount;
        const cal = (crtdiscountFiled / subtotal) * 100;
        updatedFormData.product[index].discount_percentage = isNaN(cal)
          ? 0
          : cal.toFixed(2);
      }
      let finalAmount = subtotal - crtdiscountFiled;
      updatedFormData.product[index].total_amt = finalAmount.toFixed(2);
    });
    setFormData(updatedFormData);
  };
  const handleDiscountChange = (e) => {
    const { value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      discount: value,
    }));
  };
  const handleKeyPress = (event, index) => {
    if (event.key === "Enter") {
      const lastRow = formData.product[formData.product.length - 1];
      if (
        lastRow.product_id &&
        lastRow.qty &&
        lastRow.unit &&
        lastRow.price_unit &&
        lastRow.total_amt
      ) {
        handleAddRow();
      } else {
        toast.error(
          "Please fill in all fields in the last row before adding a new row"
        );
      }
    }
  };
  const handleRemarkChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  useEffect(() => {
    calculateTotal();
  }, [formData.product, discountType, formData.discount, globalTax]);
  useEffect(() => {
    const baseTotal = parseFloat(formData.total) || 0;
    const roAmount = parseFloat(formData.round_off_amount) || 0;
    const grandTotal = baseTotal + roAmount;
    const paidAmount = parseFloat(formData.paid) || 0;
    const balance = grandTotal - paidAmount;
    setFormData((prevFormData) => ({
      ...prevFormData,
      balance_amount: balance.toFixed(2),
    }));
  }, [formData.total, formData.paid, formData.round_off_amount]);
  const [isLoggedIn, setIsLoggedIn] = useState(true);
  useEffect(() => {
    const checkSession = async () => {
      try {
        const session = localStorage.getItem("session");
        if (!session) {
          setIsLoggedIn(false);
        }
      } catch (error) {
        setIsLoggedIn(false);
      }
    };
    checkSession();
  }, []);
  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }
  const discountOptions = [
    { value: "Discount %", label: "Discount %" },
    { value: "Discount Amount", label: "Discount Amount" },
  ];
  return (
    <>
      <div className="main overflow-scroll" style={{ cursor: "pointer" }}>
        <Container fluid className="px-3">
          <Row>
            <Col lg="12" className="py-3">
              <PageHead
                pagehead={<>Sales Invoice</>}
                onClick={() => navigate(-1)}
              />
            </Col>
            <Container className="py-3">
              {/* Row 1: Party Name + Mobile Number */}
              <Row className="mb-3">
                <Col xs={12} lg={2} className="mb-3">
                  <Calender
                    setLabel={(date) => setLabel(date, "bill_date")}
                    selectedDate={
                      formData.bill_date && moment(formData.bill_date).isValid()
                        ? moment(formData.bill_date).toDate()
                        : new Date()
                    }
                    calenderlabel="Bill Date"
                  />
                </Col>
                <Col xs={12} lg={2} className="mb-3">
                  <DropDownUI
                    optionlist={partySalesData.map((user) => ({
                      value: user.party_id,
                      label: `${user.party_name} ${user.mobile_number ? `(${user.mobile_number})` : ""
                        }`,
                    }))}
                    placeholder="Party Name"
                    labelname="Party Name"
                    name="party_id"
                    value={formData.party_id}
                    onChange={(updatedFormData) => {
                      const selectedParty = partySalesData.find(
                        (user) => user.party_id === updatedFormData.party_id
                      );
                      setFormData((prev) => ({
                        ...prev,
                        party_id: updatedFormData.party_id,
                        party_name: selectedParty
                          ? selectedParty.party_name
                          : "",
                        mobile_number: selectedParty
                          ? selectedParty.mobile_number || ""
                          : "",
                        address: selectedParty
                          ? selectedParty.billing_address ||
                          selectedParty.shipp_address ||
                          ""
                          : "",
                        state_of_supply: selectedParty
                          ? selectedParty.state || ""
                          : "",
                      }));
                    }}
                  />
                </Col>
                <Col xs={12} lg={2} className="mb-3">
                  <TextInputForm
                    placeholder="Bill Number"
                    labelname="Bill Number"
                    name="bill_no"
                    value={formData.bill_no}
                    onChange={(e) => handleChange(e, "bill_no")}
                    disabled={type === "edit"}
                  />
                </Col>
                <Col xs={12} lg={2} className="mb-3">
                  <TextInputForm
                    placeholder="Mobile Number"
                    labelname="Mobile Number"
                    name="mobile_number"
                    value={formData.mobile_number}
                    onChange={(e) => handleChange(e, "mobile_number")}
                  />
                </Col>
                <Col xs={12} lg={2} className="mb-3">
                  <label className="pb-2">Address</label>
                  <textarea
                    className="form-cntrl form-control"
                    placeholder="Address"
                    labelname="Address"
                    name="address"
                    value={formData.address}
                    onChange={(e) => handleChange(e, "address")}
                  />
                </Col>
              </Row>
            </Container>
          </Row>
        </Container>
      </div>
      <div className="main my-3">
        <div>
          <Container fluid className="px-0">
            <Row>
              <Col lg="12" className="py-3">
                <div>
                  No Of Products: <span>{formData.product.length}</span>
                </div>
              </Col>
              <Col lg="12" md="6" xs="12">
                <div className="py-2 category-table bill">
                  {/* Desktop View: Horizontal Table */}
                  <div className="product-table-wrapper d-none d-lg-block">
                    <Table responsive className="product-table">
                      <thead>
                        <tr>
                          <th className="text-center">#</th>
                          <th style={{ minWidth: "250px" }}>Product Name</th>
                          <th className="text-center">Qty</th>
                          <th className="text-center">Unit</th>
                          <th className="text-center">Batch</th>
                          <th className="text-center">Price / Unit</th>
                          <th className="text-center">Amount</th>
                          <th className="text-center"></th>
                        </tr>
                      </thead>
                      <tbody>
                        {formData.product &&
                          formData.product.map((row, index) => (
                            <tr key={index}>
                              <td className="text-center font-weight-bold">{index + 1}</td>
                              <td>
                                <DropDownUItest
                                  optionlist={productData.map((user) => ({
                                    value: user.product_id,
                                    label: user.product_name,
                                  }))}
                                  placeholder="Product Name"
                                  name="product_id"
                                  value={row.product_id}
                                  onChange={(updatedFormData) => {
                                    const selectedProduct = productData.find(
                                      (user) => user.product_id === updatedFormData.product_id
                                    );
                                    if (!selectedProduct) return;

                                    const unitRate = Number(selectedProduct.unit_rate) || 0;
                                    const discountPct = Number(selectedProduct.discount || 0);
                                    const discountAmt = discountPct > 0 ? (unitRate * discountPct) / 100 : 0;
                                    const perPrice = Math.max(unitRate - discountAmt, 0);
                                    const qty = Number(formData.product[index]?.qty) || 0;
                                    const totalPrice = (qty * perPrice).toFixed(2);

                                    setFormData({
                                      ...formData,
                                      product: formData.product.map((r, i) =>
                                        i === index
                                          ? {
                                            ...r,
                                            product_id: updatedFormData.product_id,
                                            product_name: selectedProduct?.product_name || "",
                                            price_unit: perPrice.toFixed(2),
                                            total_amt: totalPrice,
                                          }
                                          : r
                                      ),
                                    });
                                  }}
                                />
                              </td>
                              <td>
                                <div className="d-flex align-items-center gap-1">
                                  <input
                                    type="text"
                                    className="table-input text-center"
                                    placeholder="qty"
                                    value={row.qty}
                                    onChange={(e) => handleChange(e, "qty", index)}
                                  />
                                  <BiPlus
                                    className="text-primary cursor-pointer"
                                    size={20}
                                    onClick={() => handleOpenQtyModal(index)}
                                    title="Add Qty"
                                  />
                                </div>
                              </td>
                              <td>
                                <DropDownUI
                                  optionlist={UnitData.map((user) => ({
                                    value: user.unit_id,
                                    label: user.unit_name,
                                  }))}
                                  value={row.unit}
                                  placeholder="Unit"
                                  onChange={(updatedFormData) => {
                                    const selectedUnit = UnitData.find(
                                      (u) => u.unit_id === updatedFormData.unit
                                    );
                                    setFormData({
                                      ...formData,
                                      product: formData.product.map((r, i) =>
                                        i === index
                                          ? {
                                            ...r,
                                            unit: updatedFormData.unit,
                                            unit_name: selectedUnit?.unit_name || "",
                                          }
                                          : r
                                      ),
                                    });
                                  }}
                                />
                              </td>
                              <td>
                                <input
                                  type="text"
                                  className="table-input text-center"
                                  placeholder="Batch"
                                  value={row.batch}
                                  onChange={(e) => handleChange(e, "batch", index)}
                                />
                              </td>
                              <td>
                                <input
                                  type="number"
                                  className="table-input text-center"
                                  placeholder="price"
                                  value={row.price_unit}
                                  onChange={(e) => handleChange(e, "price_unit", index)}
                                />
                              </td>
                              <td>
                                <input
                                  type="number"
                                  className="table-input text-center"
                                  placeholder="amt"
                                  value={row.total_amt}
                                  readOnly
                                />
                              </td>
                              <td className="text-center">
                                <MdDeleteForever
                                  className="delete-row-icon"
                                  size={40}
                                  onClick={() => handleDeleteRow(index)}
                                />
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </Table>
                  </div>

                  {/* Mobile View: Responsive List */}
                  <div className="d-lg-none">
                    {formData.product &&
                      formData.product.map((row, index) => (
                        <div key={index} className="p-3 border rounded mb-4 bg-white shadow-sm position-relative product-card">
                          <div className="badge bg-primary position-absolute top-0 start-0 m-2">#{index + 1}</div>
                          <Row className="mt-3">
                            <Col xs={12} className="mb-3">
                              <label className="form-label fw-bold small">Product Name</label>
                              <DropDownUItest
                                optionlist={productData.map((user) => ({
                                  value: user.product_id,
                                  label: user.product_name,
                                }))}
                                placeholder="Product Name"
                                name="product_id"
                                value={row.product_id}
                                onChange={(updatedFormData) => {
                                  const selectedProduct = productData.find(
                                    (user) => user.product_id === updatedFormData.product_id
                                  );
                                  if (!selectedProduct) return;

                                  const unitRate = Number(selectedProduct.unit_rate) || 0;
                                  const discountPct = Number(selectedProduct.discount || 0);
                                  const discountAmt = discountPct > 0 ? (unitRate * discountPct) / 100 : 0;
                                  const perPrice = Math.max(unitRate - discountAmt, 0);
                                  const qty = Number(formData.product[index]?.qty) || 0;
                                  const totalPrice = (qty * perPrice).toFixed(2);

                                  setFormData({
                                    ...formData,
                                    product: formData.product.map((r, i) =>
                                      i === index
                                        ? {
                                          ...r,
                                          product_id: updatedFormData.product_id,
                                          product_name: selectedProduct?.product_name || "",
                                          price_unit: perPrice.toFixed(2),
                                          total_amt: totalPrice,
                                        }
                                        : r
                                    ),
                                  });
                                }}
                              />
                            </Col>
                            <Col xs={12} className="mb-3">
                              <label className="form-label text-muted x-small">Qty</label>
                              <div className="d-flex align-items-center gap-2">
                                <input
                                  type="text"
                                  className="form-control bg-light"
                                  placeholder="Qty"
                                  value={row.qty}
                                  onChange={(e) => handleChange(e, "qty", index)}
                                />
                                <button
                                  className="btn btn-sm btn-outline-primary p-1 rounded-circle"
                                  style={{ width: '30px', height: '30px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                  onClick={() => handleOpenQtyModal(index)}
                                >
                                  <BiPlus size={18} />
                                </button>
                              </div>
                            </Col>
                            <Col xs={12} className="mb-3">
                              <label className="form-label text-muted x-small">Unit</label>
                              <DropDownUI
                                optionlist={UnitData.map((user) => ({
                                  value: user.unit_id,
                                  label: user.unit_name,
                                }))}
                                value={row.unit}
                                placeholder="Unit"
                                onChange={(updatedFormData) => {
                                  const selectedUnit = UnitData.find(
                                    (u) => u.unit_id === updatedFormData.unit
                                  );
                                  setFormData({
                                    ...formData,
                                    product: formData.product.map((r, i) =>
                                      i === index
                                        ? {
                                          ...r,
                                          unit: updatedFormData.unit,
                                          unit_name: selectedUnit?.unit_name || "",
                                        }
                                        : r
                                    ),
                                  });
                                }}
                              />
                            </Col>
                            <Col xs={12} className="mb-3">
                              <label className="form-label text-muted x-small">Batch</label>
                              <input
                                type="text"
                                className="form-control bg-light"
                                placeholder="Batch"
                                value={row.batch}
                                onChange={(e) => handleChange(e, "batch", index)}
                              />
                            </Col>
                            <Col xs={12} className="mb-3">
                              <label className="form-label text-muted x-small">Price/Unit</label>
                              <input
                                type="number"
                                className="form-control bg-light"
                                placeholder="Price"
                                value={row.price_unit}
                                onChange={(e) => handleChange(e, "price_unit", index)}
                              />
                            </Col>
                            <Col xs={12} className="mb-3">
                              <label className="form-label fw-bold x-small">Total Amount</label>
                              <div className="d-flex gap-2 align-items-center">
                                <input
                                  type="text"
                                  className="form-control fw-bold bg-light-success text-center flex-grow-1"
                                  value={row.total_amt}
                                  readOnly
                                />
                                <MdDeleteForever
                                  className="text-danger cursor-pointer"
                                  size={28}
                                  onClick={() => handleDeleteRow(index)}
                                />
                              </div>
                            </Col>
                          </Row>
                        </div>
                      ))}
                  </div>

                  <div className="btn-add-more-row">
                    <button className="btn-add-more" onClick={handleAddRow}>
                      Add More
                    </button>
                  </div>
                </div>
              </Col>
              {/* <Col lg="12" className="text-end">
                <div className="mx-1 text-primary">
                  <ClickButton label={<>Add More</>} onClick={handleAddRow} />
                </div>
              </Col> */}
            </Row>
          </Container>
        </div>
        <div className="my-3">
          <Container>
            <Row>
              <Col lg="5"></Col>
              <Col lg="7">
                <div className="inside my-3">
                  <div className="payment-card shadow-sm p-4 bg-white rounded-3 my-3">
                    <Row className="align-items-center mb-3">
                      <Col xs={5}>
                        <label className="fw-bold text-secondary">Sub Total</label>
                      </Col>
                      <Col xs={7}>
                        <input
                          type="text"
                          className="table-input payment-input bg-light"
                          placeholder="SubTotal"
                          name="subtotal"
                          value={formData.subtotal}
                          readOnly
                        />
                      </Col>
                    </Row>

                    <Row className="align-items-center mb-3">
                      <Col xs={12} md={5} className="mb-2 mb-md-0">
                        <label className="fw-bold text-secondary">Discount</label>
                      </Col>
                      <Col xs={12} md={7}>
                        <Row className="g-1">
                          <Col xs={12} sm={6}>
                            <DropDownUI
                              optionlist={discountOptions}
                              placeholder="Type"
                              name="discount_type"
                              value={discountType}
                              onChange={(updatedValue) => {
                                setDiscountType(updatedValue.discount_type);
                                setFormData((prevData) => ({
                                  ...prevData,
                                  discount_type: updatedValue.discount_type,
                                }));
                                calculateTotal();
                              }}
                            />
                          </Col>
                          <Col xs={12} sm={6}>
                            <input
                              type="number"
                              className="table-input payment-input"
                              placeholder="Value"
                              name="discount"
                              value={formData.discount}
                              onChange={handleDiscountChange}
                            />
                          </Col>
                        </Row>
                      </Col>
                    </Row>

                    <Row className="align-items-center mb-3">
                      <Col xs={5}>
                        <label className="fw-bold text-secondary">Discount Amt</label>
                      </Col>
                      <Col xs={7}>
                        <input
                          type="text"
                          className="table-input payment-input bg-light"
                          value={
                            discountType === "Discount %"
                              ? (((parseFloat(formData.subtotal) || 0) * (parseFloat(formData.discount) || 0)) / 100).toFixed(2)
                              : (parseFloat(formData.discount) || 0).toFixed(2)
                          }
                          readOnly
                        />
                      </Col>
                    </Row>

                    <Row className="align-items-center mb-3">
                      <Col xs={5}>
                        <label className="fw-bold text-secondary">Total</label>
                      </Col>
                      <Col xs={7}>
                        <input
                          type="text"
                          className="table-input payment-input bg-light fw-bold"
                          value={formData.total}
                          readOnly
                        />
                      </Col>
                    </Row>

                    <Row className="align-items-center mb-3">
                      <Col xs={5}>
                        <label className="fw-bold text-secondary small">Round Off</label>
                      </Col>
                      <Col xs={2}>
                        <input
                          type="checkbox"
                          className="form-check-input"
                          checked={formData.round_off_checkbox}
                          onChange={handleRoundOffChange}
                        />
                      </Col>
                      <Col xs={5}>
                        <input
                          type="text"
                          className="table-input payment-input bg-light text-end"
                          value={formData.round_off_amount}
                          readOnly
                        />
                      </Col>
                    </Row>

                    <Row className="align-items-center mb-3">
                      <Col xs={5}>
                        <label className="fw-bold text-secondary">Paid</label>
                      </Col>
                      <Col xs={7}>
                        <input
                          type="number"
                          className="table-input payment-input"
                          placeholder="Paid"
                          name="paid"
                          value={formData.paid}
                          onChange={handlePaidChange}
                        />
                      </Col>
                    </Row>

                    <Row className="align-items-center mb-3">
                      <Col xs={12} md={5} className="mb-2 mb-md-0">
                        <label className="fw-bold text-secondary">Select Payment</label>
                      </Col>
                      <Col xs={12} md={7}>
                        <DropDownUI
                          optionlist={crtPaymentMethod.map((user) => ({
                            value: user.payment_method_name,
                            label: user.payment_method_name,
                          }))}
                          placeholder="Select Payment"
                          name="payment_method"
                          value={formData.payment_method}
                          onChange={(updatedFormData) => {
                            setFormData({
                              ...formData,
                              payment_method: updatedFormData.payment_method,
                            });
                          }}
                        />
                      </Col>
                    </Row>

                    <Row className="align-items-center mb-3">
                      <Col xs={5}>
                        <label className="fw-bold text-secondary">Balance</label>
                      </Col>
                      <Col xs={7}>
                        <input
                          type="text"
                          className="table-input payment-input bg-light"
                          value={formData.balance_amount}
                          readOnly
                        />
                      </Col>
                    </Row>

                    <Row className="align-items-center mb-3">
                      <Col xs={5}>
                        <label className="fw-bold text-secondary">Details</label>
                      </Col>
                      <Col xs={7}>
                        <input
                          type="text"
                          className="table-input payment-input"
                          placeholder="Remark"
                          name="remark"
                          value={formData.remark}
                          onChange={handleRemarkChange}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
      <div className="main stick-bottom">
        <div className="w-50 ms-auto">
          <Container>
            <Row>
              <Col lg="12">
                <div className="text-center">
                  <ToastContainer
                    position="bottom-center"
                    autoClose={3000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="light"
                  />
                  <div className="d-flex flex-column flex-md-row justify-content-center mt-3">
                    <div className="mb-2 mx-md-2">
                      <ClickButton
                        label={<>{type === "edit" ? "Update" : "Submit"}</>}
                        disabled={loading}
                        onClick={
                          type === "edit" ? handleUpdateSubmit : handleSubmit
                        }
                      />
                    </div>
                    <div className="mb-2 mx-md-2">
                      <ClickButton
                        label={<>Cancel</>}
                        onClick={() => navigate("/console/sales/invoice")}
                      />
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
      <Modal show={showQtyModal} onHide={() => setShowQtyModal(false)} centered size="sm">
        <Modal.Header closeButton style={{ background: '#f8f9fa', borderBottom: 'none' }}>
          <Modal.Title className="fs-6 fw-bold">Add More</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4 pt-2">
          <Row className="mb-4">
            <Col>
              <label className="form-label small text-muted mb-2">Additional quantity to add:</label>
              <input
                type="number"
                className="form-control shadow-sm border-2"
                placeholder="0"
                value={additionalQty}
                onChange={(e) => setAdditionalQty(e.target.value)}
                autoFocus
                style={{ borderRadius: '10px' }}
              />
            </Col>
          </Row>
          <div className="d-grid shadow-sm" style={{ borderRadius: '10px' }}>
            <button
              className="btn btn-primary btn-sm rounded-4 fw-bold py-2"
              onClick={handleQtyAddition}
              style={{ background: '#3b82f6', border: 'none', color: '#000' }}
            >
              ADD
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};
// saleinvoice end
export default SalesInvoiceEntry;
